'use client'

import { useProductCountsQuery } from '@repo/web-ui/hooks/use-site-data'
import type { ProductCounts } from 'codegen/types'

import { TextWithAnimatedCount } from './text-with-animated-count'
import type { TextWithAnimatedCountProps } from './text-with-animated-count'

export function TextWithAnimatedProductCount({
  productType,
  ...rest
}: Omit<TextWithAnimatedCountProps, 'isLoading' | 'value'> & {
  productType: keyof Omit<
    ProductCounts,
    '__typename' | 'knitting' | 'laserCutting' | 'pngs' | 'svgs' | 'threeDPaperCrafts'
  >
}) {
  const { data, isPending } = useProductCountsQuery()
  const value = data ? data[productType] : 0

  return <TextWithAnimatedCount isLoading={isPending} value={value} {...rest} />
}
